import * as React from "react";

const MOBILE_BREAKPOINT = 1024;
const TABLET_BREAKPOINT = 1400;

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );
  const [isTablet, setIsTablet] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const mqlMobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const mqlTablet = window.matchMedia(`(max-width: ${TABLET_BREAKPOINT - 1}px)`);

    const onChange = () => {
      setIsMobile(mqlMobile.matches);
      setIsTablet(mqlTablet.matches);
    };

    mqlMobile.addEventListener("change", onChange);
    mqlTablet.addEventListener("change", onChange);

    // Initialize both states
    setIsMobile(mqlMobile.matches);
    setIsTablet(mqlTablet.matches);

    return () => {
      mqlMobile.removeEventListener("change", onChange);
      mqlTablet.removeEventListener("change", onChange);
    };
  }, []);

  return { isMobile: !!isMobile, isTablet: !!isTablet };
}
